<template>
  <v-container
    fluid
    tag="section"
    class="invites"
  >
    <v-row class="h-100">
      <v-progress-circular
        v-if="isLoading"
        size="40"
        indeterminate
      />
      <v-alert
        v-if="hasError"
        text
        prominent
        type="error"
        icon="mdi-cloud-alert"
      >
        {{ error }}
      </v-alert>
      <v-col
        v-if="hasCounterparties"
        class="col-sm-12 d-flex mt-3 flex-wrap companies-wrapper"
      >
        <div class="tables-block">
          <v-col
            cols="12"
            sm="12"
            class="pt-0 pb-2 pl-mid-0 block-company"
          >
            <v-card class="v-card-table">
              <v-card-text class="pa-0">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="bill-name">
                          Название
                        </th>
                        <th class="currency">
                          Окпо
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(counterparty, index) in counterparties"
                        :key="index"
                      >
                        <td class="bill">
                          {{ counterparty.title }}
                        </td>
                        <td class="bill-name">
                          {{ counterparty.okpo }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'MainCounterparties',

    data: () => ({}),

    computed: {
      ...mapGetters('counterparties', ['counterparties', 'isLoading', 'hasError', 'error', 'hasCounterparties']),
    },

    created () {
      this.$store.dispatch('counterparties/findAllCounterpartiesByAuthUser')
    },

  }
</script>

<style lang="scss" scoped></style>
